module.exports = __webpack_public_path__ + "static/media/9DESA35.ffd5683b.jpg";